import PanelLayoutSolid from './icons/PanelLayoutSolid.svg?react';
import PanelLayoutColumns from './icons/PanelLayoutColumns.svg?react';
import PanelLayoutCheckerboard from './icons/PanelLayoutCheckerboard.svg?react';
import PanelLayoutHorizontalBand from './icons/PanelLayoutHorizontalBand.svg?react';
import PanelLayoutRows from './icons/PanelLayoutRows.svg?react';
import PanelLayoutQuarters from './icons/PanelLayoutQuarters.svg?react';
import PanelLayoutHorizontalSplit from './icons/PanelLayoutHorizontalSplit.svg?react';
import PanelLayout from './types/PanelLayout';
import { PartKey } from '@inter-ikea-storageone/range';
import { PanelArrangement } from '@inter-ikea-storageone/range-pax';
import PanelSelection from './types/PanelSelection';

export const panelParts: PartKey[] = [
  PartKey.PANEL_1,
  PartKey.PANEL_2,
  PartKey.PANEL_3,
  PartKey.PANEL_4,
  PartKey.PANEL_5,
  PartKey.PANEL_6,
  PartKey.PANEL_7,
  PartKey.PANEL_8
];

const panelLayoutConfig: PanelLayout[] = [
  {
    arrangement: PanelArrangement.Solid,
    icon: PanelLayoutSolid,
    layout: [
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary
    ]
  },
  {
    arrangement: PanelArrangement.Columns,
    icon: PanelLayoutColumns,
    layout: [
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Secondary
    ]
  },
  {
    arrangement: PanelArrangement.Checkerboard,
    icon: PanelLayoutCheckerboard,
    layout: [
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Primary
    ]
  },
  {
    arrangement: PanelArrangement.HorizontalBand,
    icon: PanelLayoutHorizontalBand,
    layout: [
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Secondary
    ]
  },
  {
    arrangement: PanelArrangement.Rows,
    icon: PanelLayoutRows,
    layout: [
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Secondary
    ]
  },
  {
    arrangement: PanelArrangement.Quarters,
    icon: PanelLayoutQuarters,
    layout: [
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Primary
    ]
  },
  {
    arrangement: PanelArrangement.HorizontalSplit,
    icon: PanelLayoutHorizontalSplit,
    layout: [
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Secondary,
      PanelSelection.Primary,
      PanelSelection.Primary,
      PanelSelection.Secondary,
      PanelSelection.Secondary
    ]
  }
];

export default panelLayoutConfig;
